import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {CheckoutUtil} from "../../checkout-util";
import {Injectable} from "@angular/core";
import {UsanaObject} from "../../../modules/usana-object";
import {Apollo} from "apollo-angular";
import {LoggerService} from "../../../modules/common/logger.service";
import {IOrderHistoryDateRange, IOrderHistoryView} from "../../../modules/orders/orders-models";
import {OrderHistoryCacheService} from "../../../modules/orders/order-history/order-history-cache.service";
import {GetDateRanges, GetOrderView, GetOrderViews, GetPackslipPdf} from "./gql-order-history";

@Injectable({
    providedIn: 'root'
})
export class GqlOrderHistoryService extends UsanaObject {

    constructor(loggerService: LoggerService,
                private apollo: Apollo,
                private orderHistoryCacheService: OrderHistoryCacheService
    ) {
        super(loggerService);
    }

    getDateRanges(): Observable<IOrderHistoryDateRange[]> {
        return this.apollo.watchQuery({
            query: GetDateRanges,
            variables: {}
        }).valueChanges.pipe(take(1), map((data: any) => {
            const dateRanges: IOrderHistoryDateRange[] = CheckoutUtil.handleApolloResponse(data, (d) => d.data.getDateRanges);
            this.orderHistoryCacheService.setDateRanges(dateRanges);
            return dateRanges;
        }));
    }

    getOrderViews(selectedDateRange: IOrderHistoryDateRange): Observable<IOrderHistoryView[]> {
        return this.apollo.watchQuery({
            query: GetOrderViews,
            variables: {startDate: selectedDateRange.startDate, endDate: selectedDateRange.endDate}
        }).valueChanges.pipe(take(1), map((data: any) => {
            const orderViews: IOrderHistoryView[] = CheckoutUtil.handleApolloResponse(data, (d) => d.data.getOrderViews);
            this.orderHistoryCacheService.setOrderViews(selectedDateRange.tag, orderViews);
            return orderViews;
        }));
    }

    getOrderView(orderId: number): Observable<IOrderHistoryView> {
        return this.apollo.watchQuery({
            query: GetOrderView,
            variables: {orderId}
        }).valueChanges.pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getOrderView)));
    }

    getPackslipPdf(warehouseId: string, packslipId: number, orderId: number): Observable<string> {
        return this.apollo.watchQuery({
            query: GetPackslipPdf,
            variables: {warehouseId, packslipId, orderId}
        }).valueChanges.pipe(take(1), map((data: any) => data.data.getPackslipPdf));
    }
}
